module.exports = __webpack_public_path__ + "static/media/radio-mic-2.b749be28.jpg";